import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

const PLATFORM_MODE_KEY = "platform_mode";

export const usePlatformMode = () => {
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      const { data } = await supabase
        .from("store_settings")
        .select("value")
        .eq("key", PLATFORM_MODE_KEY)
        .maybeSingle();
      if (data?.value && typeof data.value === "object") {
        setEnabled((data.value as any).enabled === true);
      }
      setLoading(false);
    };
    fetch();
  }, []);

  return { enabled, loading };
};
